import { mapGetters, mapState } from 'vuex';
import infiniteLoading from 'vue-infinite-loading';
import tabs from '@/components/generics/tabs/tabs.vue';
import portfolioMyMarkets from '@/components/dashboard/portfolio-my-markets/portfolio-my-markets.vue';
import accountSocialBadge from '@/components/account/account-social-badge/account-social-badge.vue';
import dashboardMarketFilters from '@/components/market/market-filters/market-filters-dashboard/market-filters-dashboard.vue';
import dashboardMarketsToggle from '@/components/dashboard/dashboard-markets-toggle/dashboard-markets-toggle.vue';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import shareInviteWidget from '@/components/social/share-invite-widget/share-invite-widget.vue';
import leaderboardsInfo from '@/components/leaderboards/leaderboards-info/leaderboards-info.vue';
import notificationsList from '@/components/notifications-list/notifications-list.vue';
import publicProfileWidget from '@/components/profile/public-profile-widget/public-profile-widget.vue';
import loaderMixin from '@/mixins/loader';
import accountVerifyMixin from '@/mixins/accountVerify';
import socialLevelMixin from '@/mixins/socialLevel';

const NAVIGATION_TABS = {
  MY_MARKETS: 'my-markets',
  LEADERBOARD_INFO: 'leaderboard-info',
  INVITE_FRIENDS: 'invite-friends',
  NOTIFICATIONS: 'notifications'
};

const NAVIGATION_TABS_ROUTES = {
  [NAVIGATION_TABS.MY_MARKETS]: 'portfolio',
  [NAVIGATION_TABS.LEADERBOARD_INFO]: 'dashboard-leaderboard-info',
  [NAVIGATION_TABS.INVITE_FRIENDS]: 'dashboard-invite-friends',
  [NAVIGATION_TABS.NOTIFICATIONS]: 'dashboard-notifications',
};

const NAVIGATION_ROUTES_TABS = Object.fromEntries(Object.entries(NAVIGATION_TABS_ROUTES).map(([k, v]) => [v, k]))

export default {
  mixins: [
    accountVerifyMixin,
    socialLevelMixin,
    loaderMixin,
  ],
  components: {
    publicProfileWidget,
    leaderboardsInfo,
    shareInviteWidget,
    infiniteLoading,
    tabs,
    portfolioMyMarkets,
    accountSocialBadge,
    dashboardMarketFilters,
    marketChangePrice,
    dashboardMarketsToggle,
    notificationsList,
  },
  data() {
    return {
      activeNavigationTab: null,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('dashboard', ['mySharesTotalGainLoss']),
    ...mapGetters('wallet', ['portfolioValueDecimal']),
    ...mapState('dashboard', ['mySharesReady']),
    ...mapState('wallet', ['balance']),
    classModifiers() {
      return {
        'page-dashboard-sushi': true,
        [`page-dashboard-sushi--${this.$route.name}`]: this.$route.name,
      };
    },
    navigationTabs () {
      return [
        {
          name: NAVIGATION_TABS.MY_MARKETS,
          title: 'My Markets',
        },
        // {
        //   name: NAVIGATION_TABS.LEADERBOARD_INFO,
        //   title: 'Profile',
        // },
        {
          name: NAVIGATION_TABS.INVITE_FRIENDS,
          title: this.isLayoutMobile ? 'Invite' : 'Invite Friends',
        },
        {
          name: NAVIGATION_TABS.NOTIFICATIONS,
          title: 'Notifications',
        },
      ];
    },
    portfolioValueReady() {
      return true;
      // return !this.balance.isDefault && this.mySharesReady;
    },
    gainLossClassModifiers() {
      const value = this.mySharesTotalGainLoss;
      return {
        'page-dashboard-sushi__gain-loss': true,
        'page-dashboard-sushi__gain-loss--plus': value > 0,
        'page-dashboard-sushi__gain-loss--minus': value < 0,
      };
    },
  },
  methods: {
    navigationTabChange(name) {
      this.activeNavigationTab = name;
      const routeName = NAVIGATION_TABS_ROUTES[name];
      if (routeName !== this.$route.name) {
        this.$router.push({ name: NAVIGATION_TABS_ROUTES[name] });
      }
    },
  },
  watch: {
    $route(to, from) {
      this.activeNavigationTab = NAVIGATION_ROUTES_TABS[to.name]
    },
  },
  created() {
    this.activeNavigationTab = NAVIGATION_ROUTES_TABS[this.$route.name]
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/page-dashboard-sushi/page-dashboard-sushi.js